// Import Packages
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

// Import Icons
import { CircularProgress, Tooltip } from '@material-ui/core';
import emptyPageIcon from '../../../../assets/icons/configurationIcons/empty-page.svg';
import QueueService from '../../../../services/QueueService/QueueService';
import LogSummaryDetail from './LogSummaryDetail';



const LogSummary = ({ data, handleOpenInfoArea, setOpenEhLogs, label }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false)
    const [logs, setLogs] = useState([])
    const [totalActionCount, setTotalActionCount] = useState()


    useEffect(() => {
        fetchData()
    }, [data])

    const fetchData = () => {
        // Şu anki tarih ve saat
        var startDate = new Date();

        // 24 saat önceki tarih ve saat
        var endDate = new Date();
        endDate.setDate(endDate.getDate() - 1); // Dünden başla
        endDate.setHours(startDate.getHours()); // Saati aynı yap

        setLoading(true);
        QueueService.getQueueActivityLog(`?operation_id=${data.operation_id}`, endDate, startDate, 0, 5, undefined, "summary", true)
            .then((response) => {
                if (Array.isArray(response?.data)) {
                    setLogs(response.data);
                    setTotalActionCount(response.total_action_count)
                } else {
                    setLogs([]);
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                //err
            });
    }

    return (
        <>
            {loading ? <div className='db-create-loading-page log-summary-container'><CircularProgress /></div>
                : logs.length ? logs.map((log, index) => {
                    return <LogSummaryDetail logs={logs} data={data} log={log} index={index} totalActionCount={totalActionCount} handleOpenInfoArea={handleOpenInfoArea}
                        setOpenEhLogs={setOpenEhLogs} />
                })
                    : <div className='empty-page-info-container'>
                        <img alt="empty-page-icon" src={emptyPageIcon} />
                        <p className='info-text'>{t(label + 'EMPTY-LOGS')}</p>
                    </div>
            }
        </>
    )
}

export default LogSummary